import type { StateCreator } from 'zustand';
import type { GuidedDoctorConsultsActions, GuidedDoctorConsultsSliceType } from '../types';

export const closeAllSections: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsActions['closeAllSections']
> = (set) => {
  return () => {
    set(
      (state) => {
        state.guidedDoctorConsult.openSections = [];
      },
      false,
      'guidedDoctorConsult/closeAllSections',
    );
  };
};
